//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import { useState, useEffect, useCallback } from "react";

const useForm = (initialValues, callback, validate) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) callback(values);
    // eslint-disable-next-line
  }, [errors]);

  const handleSubmit = useCallback(() => {
    setErrors(false);
    if (validate !== undefined && validate) setErrors(validate(values));
    setIsSubmitting(true);
  }, [values]);

  const checkError = useCallback(
    () => {
      setErrors(false);
      if (validate !== undefined && validate) setErrors(validate(values));
      setIsSubmitting(false);
      // eslint-disable-next-line
    },
    // eslint-disable-next-line
    [values]
  );

  const handleCurrentVal = (obj) => {
    setValues(obj);
  };

  const resetForm = useCallback(() => {
    setIsSubmitting(false);
    setErrors({});
    setValues(initialValues);
    // eslint-disable-next-line
  }, []);

  const setUpdateValue = useCallback((field, value) => {
    setValues((values) => ({
      ...values,
      [field]: value,
    }));
  }, []);

  const handleChange = useCallback((e) => {
    setValues((values) => ({
      ...values,
      [e.name]: e.value,
    }));
  }, []);

  const handleKeyPress = useCallback(
    (e) => {
      if (!/^\d{1,10}(\.\d{0,4})?$/.test(e.target.value)) {
        e.persist();
        return null;
      }
      let thisName = e.target.name;
      let thisValue = e.target.value;
      setValues((values) => ({
        ...values,
        [thisName]: thisValue,
      }));
      // eslint-disable-next-line
    },
    // eslint-disable-next-line
    [values]
  );

  const handleDateChange = useCallback((date, name = "date") => {
    date = new Date(date);
    let value = date.getTime();
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
    // eslint-disable-next-line
  }, []);

  const handleSelectChange = useCallback((e, name = "select") => {
    let value = e ? e.value : null;
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
    // eslint-disable-next-line
  }, []);

  const handleRadioChange = useCallback((e) => {
    let value = e.target.value;
    let name = e.target.name;
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
    // eslint-disable-next-line
  }, []);

  const handleMultiSelectChange = useCallback((e, name = "mselect") => {
    let itemIds = [];
    if (e !== null && e.length > 0) {
      e.forEach((item) => {
        itemIds.push(item.value);
      });
    }

    setValues((values) => ({
      ...values,
      [name]: itemIds,
      [name + "Label"]: e,
    }));

    // eslint-disable-next-line
  }, []);

  const handleCheckboxChange = useCallback((value, name = "checkbox") => {
    setValues((values) => ({
      ...values,
      [name]: value,
    }));
    // eslint-disable-next-line
  }, []);

  const handleFileChange = useCallback((e) => {
    e.persist();
    setValues((values) => ({
      ...values,
      [e.target.name]: e.target.files[0],
    }));
    // eslint-disable-next-line
  }, []);

  return {
    handleChange,
    handleDateChange,
    handleSelectChange,
    handleKeyPress,
    handleMultiSelectChange,
    handleSubmit,
    values,
    setUpdateValue,
    errors,
    resetForm,
    handleCurrentVal,
    handleCheckboxChange,
    handleFileChange,
    handleRadioChange,
    checkError,
  };
};

export default useForm;
